const width = 2880;
const height = 1440;
const labelWidth: number = 500;
const labelHeight = 120;
const spaceX = 50;
const spaceY = 80;
const mainLabelWidth: number = 700;
export {labelWidth, labelHeight, spaceX, spaceY, mainLabelWidth, width, height}

export function throttle(fn,timer){
  let init_time = 0;
  // 回调函数提供给drag事件
  return function(this: any, ...args){
    let now_time = +new Date();
    if(now_time-init_time > timer){
      init_time = now_time;
      fn.apply(this,args);
    }
  }
}

export const amountMap = {
  4: '获投金额',
  def: '认缴金额'
};

export const colorMap = {
  //文字颜色 背景颜色 边框颜色 悬停边框颜色
  1: ['rgb(38,40,37)', 'rgb(234,247,231)', 'rgb(111,199,95)', 'rgb(111,255,95)'], //主基金
  2: ['rgb(38,40,37)', 'rgb(234,247,231)', 'rgb(111,199,95)', 'rgb(111,255,95)'], //专项基金
  3: ['rgb(38,40,37)', 'rgb(254,250,228)', 'rgb(243,217,64)', 'rgb(253,243,64)'], //SPV
  4: ['rgb(38,40,37)', 'rgb(253,253,252)', '#aaaaaa', '#aaaaaa'], //项目
  5: ['rgb(38,40,37)', 'rgb(240,248,254)', 'rgb(171,207,253)', 'rgb(171,253,253)'], //LP
  def: ['#ffffff', 'rgb(67,148,252)', '#aaaaaa', '#aaaaaa']
};


export function calWidth(node) {
  if (!node.children || !node.spread) {
    node.width = labelWidth;
    return node.width;
  } else {
    node.width =
      node.children.reduce((width, item) => {
        return width + calWidth(item);
      }, 0) +
      (node.children.length - 1) * spaceX;
    return node.width;
  }
}

export function wrapWord(text, width) {
  const chSize = 500 / 15;
  const lowSize = 500 / 27;
  const upSize = 500 / 22;
  const spaceSize = 500 / 44;
  let index1, index2;
  let string1, string2;
  let widthList = text.split('').map(char => {
    if (/[\u4e00-\u9fa5（）]/.test(char)) {
      return chSize;
    } else if (/[a-z]/.test(char)) {
      return lowSize;
    } else if (/[A-Z)(-]/.test(char)) {
      return upSize;
    } else if (/[)(\s\.,]/.test(char)) {
      return spaceSize;
    } else {
      return chSize;
    }
  });
  widthList.reduce((total, cur, index) => {
    let newTotal = total + cur;
    if (newTotal > width && total <= width) {
      index1 = index;
    }
    if (newTotal > 2 * width - 50 && total <= 2 * width - 50) {
      index2 = index;
    }
    return newTotal;
  }, 0);
  if (index1) {
    string1 = text.slice(0, index1);
    if (index2) {
      string2 = text.slice(index1, index2) + '...';
    } else {
      string2 = text.slice(index1);
    }
    return [string1, string2];
  } else {
    string1 = text;
    return [string1];
  }
}

export const legendArray = [
  {
    name: 'LP',
    color: colorMap[5]
  },
  {
    name: '基金(主基金&专项基金)',
    color: colorMap[1]
  },
  {
    name: 'SPV',
    color: colorMap[3]
  },
  {
    name: 'Portfolio',
    color: colorMap[4]
  }
]